import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock, Save, FileText } from "lucide-react";
import { http, formatApiError } from "../lib/api";

const FooterPreview = ({ custom }) => (
  <div data-testid="pdf-footer-preview" className="border border-dashed border-slate-300 rounded-md bg-slate-50 px-4 py-3 text-center">
    <div className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Aperçu du texte libre (bas de toutes les pages)</div>
    {custom.split("\n").filter((l) => l.trim()).slice(0, 3).map((l, i) => <div key={i} className="text-[10px] text-slate-600 truncate">{l}</div>)}
  </div>
);

export const PdfFooterSettings = () => {
  const [d, setD] = useState(null);
  const [custom, setCustom] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/settings/pdf-footer").then((r) => { setD(r.data); setCustom(r.data.custom); }); }, []);
  if (!d) return null;
  const lines = custom.split("\n").filter((l) => l.trim()).length;
  const save = async () => {
    setBusy(true);
    try { await http.put("/settings/pdf-footer/custom", { text: custom }); toast.success("Texte enregistré — appliqué à tous les PDF"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="pdf-footer-settings" className="border border-slate-200 bg-white rounded-md p-6 space-y-5">
      <div className="flex items-center gap-2"><FileText className="h-5 w-5 text-slate-700" /><h3 className="font-display text-lg font-extrabold">Pied de page des PDF</h3></div>
      <p className="text-xs text-slate-500 -mt-3">Texte affiché en bas de tous les PDF (devis, factures, plannings, fiches agents, rapports, documents). Laissez vide pour conserver le pied de page avec vos mentions légales.</p>
      <div>
        <label className="text-sm font-semibold flex items-center gap-1.5">Texte libre (3 lignes max.) {!d.can_edit_custom && <span className="inline-flex items-center gap-1 text-[11px] font-bold text-slate-500"><Lock className="h-3 w-3" /> Réservé à l'administrateur principal</span>}</label>
        <textarea data-testid="pdf-footer-custom-input" rows={3} value={custom} disabled={!d.can_edit_custom}
                  onChange={(e) => { const v = e.target.value; if (v.split("\n").length <= 3) setCustom(v); }}
                  className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2 text-sm disabled:bg-slate-100 disabled:text-slate-500" placeholder="Ex. RCS Paris 123 456 789 — Autorisation CNAPS AUT-075-2116-01-01-2020…" />
        <div className="flex items-center justify-between mt-1">
          <span data-testid="pdf-footer-custom-count" className="text-[11px] text-slate-500">{lines}/3 lignes</span>
          {d.can_edit_custom && <button data-testid="pdf-footer-custom-save" onClick={save} disabled={busy} className="inline-flex items-center gap-1.5 bg-slate-900 text-white px-3 py-2 rounded-md text-sm font-semibold disabled:opacity-60"><Save className="h-4 w-4" /> Enregistrer</button>}
        </div>
      </div>
      {lines > 0 && <FooterPreview custom={custom} />}
    </div>
  );
};
